import type { FaireProductEntity } from "../../entity_types/product";

export const p_rdtyczrb6m: FaireProductEntity = {
  token: "p_rdtyczrb6m",
  type: "product",
  name: "Organic Penne Ancient Grain Pasta",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/f9aadf35ae84ed471062c402624b1d327a80dd5d887281e424734576e3c8970c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b7eeac4d10572ec455dd141d17773f14370c783e0b283525e721b5b218fe9029.jpeg",
    "https://cdn.faire.com/fastly/305d72cef885e9bd898fcf8f92913d32b0f341dc48f67a748e66a97cdf70b28a.jpeg",
    "https://cdn.faire.com/fastly/9b2a921d0da2cc87647769baa121734fd9be50d416049c2e9027e1af4908e18c.jpeg",
    "https://cdn.faire.com/fastly/6831c4b62641c68a437c20175b9208439a294639e8fa368e1f44186efb4565e3.jpeg"
  ],
  priceDollars: 5.98,
  description: "At Bona Furtuna, we honor Sicilian history by marrying heirloom grains with modern technology to honor heritage and ensure authentic taste in every bite of our Italian organic pasta. Born in Sicily and perfected all over Italy, Penne features a cylindrical shape with diagonal ends, trapping morsels and making it the best pasta for meat sauce. Our Sicilian Ancient Grain Penne is 100% organic, non-GMO, and bronze died for robust flavor and texture.",
  tags: [],
  msrpDollars: 11.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:24.812Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
